// extracted by mini-css-extract-plugin
export var content = "_4l-3";
export var list = "_4l-4";
export var settingsContent = "_4l-7";
export var settingsPanel = "_4l-8";
export var state = "_4l-6";
export var triggerBadge = "_4l-2";
export var triggerButton = "_4l-1";
export var triggerShell = "_4l-0";
export var unreadDot = "_4l-5";